import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import DownloadSubTab from "./SubTabs/DownloadSubTab";
import GmailMappingsSubTab from "./SubTabs/GmailMappingsSubTab";
import SheetSettingsSubTab from "./SubTabs/SheetSettingsSubTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const CredentialsTab = () => {
  const [credentialsSubTab, setCredentialsSubTab] = useState(0);

  const handleCredentialsSubTabChange = (event, newValue) => {
    setCredentialsSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={credentialsSubTab}
              onChange={handleCredentialsSubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Download Management" />
              <Tab label="Gmail Mappings" />
              <Tab label="Sheet Settings" />
            </Tabs>
          </Box>

          {/* Download Tab */}
          <TabPanel value={credentialsSubTab} index={0}>
            <DownloadSubTab />
          </TabPanel>
          {/* Gmail Mappings Tab */}
          <TabPanel value={credentialsSubTab} index={1}>
            <GmailMappingsSubTab />
          </TabPanel>
          {/* Sheet Settings Tab */}
          <TabPanel value={credentialsSubTab} index={2}>
            <SheetSettingsSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CredentialsTab;
